export const MAX_IMPRESSIONS_PER_REQUEST = 50;

/**
 * Collects content ids and sends them in batches. Each id is sent at most once for the lifetime of
 * the queue (i.e. once per page session). Sending is fire-and-forget: failures are swallowed and not retried.
 */
export function createImpressionQueue(send: (contentIds: string[]) => Promise<unknown>) {
  const seen = new Set<string>();
  let pending: string[] = [];

  return {
    add(contentId: string) {
      if (seen.has(contentId)) return;
      seen.add(contentId);
      pending.push(contentId);
    },
    hasPending() {
      return pending.length > 0;
    },
    flush() {
      const ids = pending;
      pending = [];
      for (let i = 0; i < ids.length; i += MAX_IMPRESSIONS_PER_REQUEST) {
        send(ids.slice(i, i + MAX_IMPRESSIONS_PER_REQUEST)).catch(() => {});
      }
    },
  };
}
